<template>
  <div>
    <v-touch @swipeleft="callNext" @swiperight="callPrev">
      <div class="image-wrapper" >
        <div
             v-for="(image, key) in computedImages" :key="key">
          <transition
                  :enter-active-class="transitionNext"
                  :leave-active-class="transitionPrev"
                  mode="out-in"
                  appear>
            <div class="image" :style="{ 'background-image': 'url(' + image.src + ')'}"
                 style="background-size: cover;" v-show="key == currentNumber && show" key="key"></div>
            <!--<img  :src="image.image.url" alt="" v-show="key == currentNumber" key="key">-->
          </transition>
        </div>
      </div>

      <div class="vue-preload-image" v-if="!show">
        <div class="progress">
          <slot name="loader"></slot>
          <p class="tip-str" v-if="tipStrShow">{{tipStr}}</p>
          <!--<p class="progress-str" v-if="progressShow">{{progressStr}}</p>-->
        </div>
      </div>
    </v-touch>

  </div>

</template>

<script>
  import { mapMutations } from 'vuex'

  import eventHub from '@/components/image-slider/EventHub.js'
  // import preloadImage from 'vue-preload-image'

  export default {
    name      : "image-slider",
    props     : {
      slides       : {
        type    : Array,
        required: true,
      },
      transitionType: {
        type: String,
        default: 'fade'
      },
      tipStrShow   : {
        type   : Boolean,
        default: true,
      },
      tipStr       : {
        type   : String,
        default: 'loading...'
      }
    },
    components: {},
    data() {
      return {
        currentNumber: 0,
        timer        : null,
        interval     : 3000,
        show         : false,
        progressStr  : '',
        imgsSum      : NaN,
        tempArr      : [],
        loadedCount  : 0,
        images       : [],
        debug        : false,
        transitionNext: 'animated fadeInRight',
        transitionPrev: 'animated fadeOutLeft',
      }
    },

    computed  : {

      isPaused: {
        get(){
          return this.$store.state.slider.isPaused;
        },
        set(val){
          // console.log(val);
          this.togglePlay(val);
        }
      },
      computedImages: function () {
        return this.images;
      }

    },

    methods   : {
      ...mapMutations('slider', [
        // 'next',
        // 'prev',
        'togglePlay',
        'toggleFullScreen',
      ]),
      init() {
        this.resetImages();
        this.preloadImages(this.slides);
      },
      resetImages() {
        this.show = false;
        for(let i = 0; i < this.tempArr.length; i++) {
          this.tempArr[i].removeEventListener('load', this.imagesLoaded);
        }
        this.tempArr = [];
        this.images.splice(0);
        this.loadedCount = 0;
        this.currentNumber = 0;
        this.stopRotation();
      },
      preloadImages(imgArr) {
        for (let i = 0; i < imgArr.length; i++) {
          this.tempArr[i]        = new Image();
          this.tempArr[i].addEventListener('load', this.imagesLoaded);
          this.tempArr[i].src    = imgArr[i];
          // this.tempArr[i].src    = imgArr[i].image.url;
        }
      },

      imagesLoaded() {
        this.loadedCount++;
        if (this.loadedCount >= this.slides.length) {
          this.images = this.tempArr;
          this.show = true;
          this.startRotation();
        }
      },

      //Play Functions
      startRotation: function () {
        if (this.isPaused == true) {
          this.next();
        }
        this.timer = setInterval(this.next, this.interval);
        // if (this.debug) console.info('Slider PLAYING');
        // eventHub.$emit('play');

        // this.isPaused = false;
      },

      stopRotation: function () {
        clearTimeout(this.timer);
        this.timer = null;
        // if (this.isPaused === false && this.debug) console.info('Slider PAUSED');
        // eventHub.$emit('pause');
        // this.isPaused = true;
      },
      next        : function () {
        // if (this.debug) console.log('Current Number: ',this.currentNumber);

        if (this.currentNumber < this.images.length - 1) {
          this.currentNumber += 1
        } else {
          this.currentNumber = 0;
        }
      },
      prev        : function () {
        if (this.currentNumber > 0) {
          this.currentNumber -= 1
        } else {
          this.currentNumber = this.images.length - 1;
        }
      },
      callNext() {
        this.stopRotation();
        this.transitionNext = 'animated fadeInRight';
        this.transitionPrev = 'animated fadeOutLeft';
        this.next();
        if (this.isPaused == false) {
          this.togglePlay(true);
          // eventHub.$emit('pause');
        }
      },
      callPrev() {
        this.stopRotation();
        this.transitionNext = 'animated fadeInLeft';
        this.transitionPrev = 'animated fadeOutRight';
        this.prev();
        if (this.isPaused == false) {
          this.togglePlay(true);
          // eventHub.$emit('pause');
        }
      },
      setKeyboard(e) {
        // if (this.debug) console.log(e.keyCode);
        if (e.keyCode === 39) this.callNext();
        if (e.keyCode === 37) this.callPrev();
        if (e.keyCode === 32) this.isPaused = !this.isPaused;
      },
    },
    created() {
      window.addEventListener('keyup', this.setKeyboard);
    },
    beforeDestroy: function () {
      window.removeEventListener('keyup', this.setKeyboard);
    },
    mounted() {
      this.init();
      eventHub.$on('next', this.callNext);
      eventHub.$on('prev', this.callPrev);
      eventHub.$on('togglePlay', this.togglePlay);
      /*eventHub.$on('load-slides', () => {
        console.log('load-slides');
        // this.init();
      });*/

    },
    watch     : {
      slides() {
        // if (this.debug) console.log('Prop changed: ', newVal, ' | was: ', oldVal);
        this.init();
      },
      isPaused(val) {
        val ? this.stopRotation() : this.startRotation();
      }
    },
  }

</script>

<style scoped lang="scss">

  .animated {
    animation-duration: .9s;
    animation-fill-mode: both;
    /*animation-timing-function: ease-in-out;*/
    backface-visibility: hidden;
    z-index: 1;
    /*animation-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);*/
    animation-timing-function: cubic-bezier(0.415, 0.610, 0.355, 1.000);
    will-change: transform;
  }

  @mixin animate($name) {

  }

  $translateAmount: 20px;

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      -webkit-transform: translate3d(-#{$translateAmount}, 0, 0);
      transform: translate3d(-#{$translateAmount}, 0, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInLeft {
    -webkit-animation-name: fadeInLeft;
    animation-name: fadeInLeft;
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      -webkit-transform: translate3d($translateAmount, 0, 0);
      transform: translate3d($translateAmount, 0, 0);
    }

    to {
      opacity: 1;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInRight {
    -webkit-animation-name: fadeInRight;
    animation-name: fadeInRight;
  }

  @keyframes fadeOutLeft {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: translate3d(-#{$translateAmount}, 0, 0);
      transform: translate3d(-#{$translateAmount}, 0, 0);
      position: absolute;
    }
  }

  .fadeOutLeft {
    -webkit-animation-name: fadeOutLeft;
    animation-name: fadeOutLeft;
  }

  @keyframes fadeOutRight {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
      -webkit-transform: translate3d($translateAmount, 0, 0);
      transform: translate3d($translateAmount, 0, 0);
      position: absolute;
    }
  }

  .fadeOutRight {
    -webkit-animation-name: fadeOutRight;
    animation-name: fadeOutRight;
  }


  .spinner.centered {
    position: absolute;
    left: 48%;
    /*top: calc(50vh + 20px);*/
    top: 50vh;
  }


  .fade-enter, .fade-leave {
    opacity: 0;
    visibility: hidden;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */
  {
    opacity: 0
  }

  .image-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    div {
      /*position: absolute;*/
    }
    img, .image {
      position: absolute;
      /*position: relative;*/
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-position: 50%;
    }
  }

  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-fade-enter-active {
    transition: all .5s ease;
  }

  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */
  {
    transform: translateX(10px);
    opacity: 0;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }

  .vue-preload-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: table;
    text-align: center;
    .progress {
      position: relative;
      display: table-cell;
      vertical-align: middle;
      p {
        margin: 0;
        color: white;
      }
      .tip-str {
        margin-bottom: .8em;
      }
      .loadingAnimation {
        width: 60px;
        height: 60px;
        background-color: #67CF22;

        margin: 0 auto;
        -webkit-animation: rotateplane 1.2s infinite ease-in-out;
        animation: rotateplane 1.2s infinite ease-in-out;
      }

      @keyframes rotateplane {
        0% {
          transform: perspective(120px) rotateX(0deg) rotateY(0deg);
        }
        50% {
          transform: perspective(120px) rotateX(-180.1deg) rotateY(0deg);
        }
        100% {
          transform: perspective(120px) rotateX(-180deg) rotateY(-179.9deg);
        }
      }
    }
  }

</style>
